import { render, staticRenderFns } from "./CreateNewMessageModal.vue?vue&type=template&id=4b99b3ab&scoped=true&"
import script from "./CreateNewMessageModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99b3ab",
  null
  
)

export default component.exports